import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/checkcircle.svg'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $setup.props.isOpen,
    classes: "modal-wrapper",
    showClose: false,
    onClose: $setup.onClose
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", { class: "modal-wrapper" }, [
        _cache[0] || (_cache[0] = _createElementVNode("img", {
          class: "icon",
          src: _imports_0
        }, null, -1)),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "modal-title bold" }, "Contract created!", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "modal-body" }, [
          _createElementVNode("div", { class: "text-container" }, [
            _createElementVNode("div", { class: "text" }, "You have successfully generated a new contract with DocuSign.")
          ])
        ], -1)),
        _createElementVNode("div", { class: "controls" }, [
          _createElementVNode("button", {
            class: "button primary",
            type: "submit",
            onClick: $setup.onClose
          }, "Close")
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}